export default () => ({
  reportMain: {
    width: '95%'
  },
  pageMainContainer: {
    margin: '20px 10px 0px 10px', 
    width: '99%', 
    height: '95%',
  },
  reportMainContainer: {
    margin: '0',
    position: 'relative',
    width: '100%', 
    height: '100%',
    '& div': {
      width: '100%',
      height: '100%',
      '& iframe': {
        border: 'none',
      }
    }
  },
});